// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__wZkJz","Title":"Header_Title__oyosB","SideButtonContainer":"Header_SideButtonContainer__0LTQz"};